import axios from 'axios'

export default class {
  _reportsPdfUrl
  _reportsXmlUrl
  constructor() {
    this._reportsPdfUrl = `${process.env.VUE_APP_API_PSC_URL}${process.env.VUE_APP_API_PSC_PDF}`
    this._reportsXmlUrl = `${process.env.VUE_APP_API_PSC_URL}${process.env.VUE_APP_API_PSC_XML}`
  }

  downloadPdf(documentId) {
    return axios.get(`${this._reportsPdfUrl}/${documentId}`,{
      responseType: 'arraybuffer'
    })
  }

  downloadXml(documentId) {
    return axios.get(`${this._reportsXmlUrl}/${documentId}`)
  }
}
